<div
  class="file-upload-container col-md-12" *ngIf="!isObjectEmpty(data)"
>
  <div class="w-100">
    <span class="data-label" *ngIf="data.fileUploadLabel?.trim()">{{ data.fileUploadLabel }}</span>
    <div class="container upload-card w-100 v-center rounded">
      <div class="d-flex flex-row align-items-start gap-2 flex-column text-center">
        <!-- <button [hidden]="viewOnly" class="upload-button" (click)="fileInput.click()">
          {{ data.buttonLabel ? data.buttonLabel : "Choose File" }}
        </button> -->

          <img src="assets/images/virtusa-icons/upload-light.svg" alt="download" (click)="fileInput.click()" (keydown)="fileInput.click()" class="m-auto img-upload">
          <input
          #fileInput
          type="file"
          [accept]="data.fileTypes"
          class="hidden-input"
          (change)="onFileChange($event)"
          [multiple]="data.allowMultiple"
        />
        

        <div class="d-flex flex-column align-items-center m-auto">
          <div class="d-flex flex-grow-1">
            <span class="file-type-label label-prefix">{{data.buttonlabelPrefix}}</span>
            <span class="no-file-label pl-1" *ngIf="files == '' && !value" (click)="fileInput.click()" (keydown)="fileInput.click()"> Choose File </span>
          </div>
          <span *ngIf="files != ''">{{ files }}</span>
          <span *ngIf="!files && value"> {{value}}</span>
          <span [hidden]="viewOnly" class="file-type-label"> {{ data.placeholderText || 'Only .CSV files, Max 25MB' }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
